import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import ReportsService from "../../Services/http/ReportsService";

export const uploadReports = async (dispatch, files, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await ReportsService.uploadReports(
    accountId, files
  );
  dispatch(setIsActiveSpinner(false));
  return response;
};

export const downloadReport = async (dispatch, accountId, reportType, reportName) => {
  dispatch(setIsActiveSpinner(true));
  const blob = await ReportsService.downloadReport(
    accountId, reportType
  );
  if (blob && blob['type'] !== 'text/html') {
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = `${reportName}.xlsx`;
    a.click();
  }
  dispatch(setIsActiveSpinner(false));
};

export const getLastUpdateDateReport = async (dispatch, accountId, reportType) => {
  dispatch(setIsActiveSpinner(true));
  const res = await ReportsService.getLastUpdateDateReport(
    accountId, reportType
  );
  if (!res || res['message'] !== 'success') {
    alert('error');
  }
  dispatch(setIsActiveSpinner(false));
  return res['last_update_date'];
};

